import React from 'react';
import { Check } from 'lucide-react';
const reasons = ['Certified Black Belt Instructors', 'Structured, Age-Appropriate Curriculum', 'Safe, Clean & Positive Environment', 'Focus on Character Development', 'Clear Belt Progression System', 'Supportive Family Community'];
export function WhyUs() {
  return <div className="py-16 md:py-24 bg-gray-900 text-white overflow-hidden relative" data-id="element-155">
      {/* Background Pattern */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gray-800/20 skew-x-12 translate-x-1/4" data-id="element-156" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-157">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-158">
          <div data-id="element-159">
            <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-160">
              Why Parents Choose <br data-id="element-161" />
              <span className="text-red-500" data-id="element-162">Watson Martial Arts</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-163">
              We don't just teach kicking and punching. We partner with parents
              to help raise strong, confident, and respectful leaders of
              tomorrow.
            </p>

            <div className="grid sm:grid-cols-2 gap-x-4 gap-y-6" data-id="element-164">
              {reasons.map((reason, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-165">
                  <div className="mt-1 w-5 h-5 rounded-full bg-red-600 flex items-center justify-center flex-shrink-0" data-id="element-166">
                    <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-167" />
                  </div>
                  <span className="font-medium text-gray-200" data-id="element-168">{reason}</span>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-169">
            <div className="aspect-video md:aspect-square rounded-2xl bg-gray-800 border-2 border-gray-700 flex items-center justify-center overflow-hidden shadow-2xl" data-id="element-170">
              <span className="text-gray-600 font-mono uppercase tracking-widest" data-id="element-171">
                [Dojo Interior / Class Photo]
              </span>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-red-600 rounded-lg -z-10" data-id="element-172" />
            <div className="absolute -top-6 -right-6 w-24 h-24 border-4 border-gray-700 rounded-lg -z-10" data-id="element-173" />
          </div>
        </div>
      </div>
    </div>;
}